/**
 * Fetcher auth — login & profile.
 *
 * Login DI-LUAR interceptor token (request login tidak butuh token).
 * Untuk profile, token sudah di-inject otomatis via http.js interceptor.
 */
import http from "@/config/http";

export async function loginUser(payload) {
  const { data } = await http.post("/api/v1/auth/login", payload);
  return data;
}

export async function fetchProfile() {
  const { data } = await http.get("/api/v1/auth/profile");
  return data;
}
